
import Select from 'react-select';
import {useState} from "react";

export default function SelectWeex({options, onChange, placeholder, onInputChange = null, onEnter = null, value = null, valueRaw = null, isDisabled = false, defaultInputValue = "", isSearchable = true, isClearable = true, isMulti = false, style = null, label = null, light = false,...props}){
  //todo do containerstyle better: remove it und use style instead wie angefangen mit background
  //style it: https://react-select.com/styles

  const [menuOpen, setMenuOpen] = useState(false)

  const styles = {
    control: (baseStyles) => ({
      ...baseStyles,
      borderWidth: 0,
      boxSizing: "inherit",
      cursor: isSearchable? "text" : "pointer",
      background: light? "var(--darkgray)": "var(--background)",
      border: "2px var(--white) solid",
      borderRadius: menuOpen? "7px 7px 0px 0px":"7px",
      borderBottom: menuOpen? "none":null,
      color: "var(--white)",
      padding: "0px 4px"
    }),
    placeholder: (baseStyles) => ({
      ...baseStyles,
      color: "var(--white)",
      opacity: "60%",
      margin: 0
    }),
    input: (baseStyles) => ({
      ...baseStyles,
      color: "var(--white)",
      margin: 0,
      padding: "2px"
    }),
    singleValue: (baseStyles) => ({
      ...baseStyles,
      color: "var(--white)",
      margin: 0
    }),
    clearIndicator: (baseStyles) => ({
      ...baseStyles,
      color: "var(--white)",
    }),
    option: (baseStyles) => ({
      ...baseStyles,
      background: light? "var(--darkgray)": "var(--background)",
    }),
    indicatorsContainer: (baseStyles) => ({
      ...baseStyles,
    }),
    indicatorSeparator: () =>({
    }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      padding: 0,
      // flexDirection: "column",
      // overflowX: "scroll",
      // maxHeight: ElementStyles.height,
      background: light? "var(--darkgray)": "var(--background)",
    }),
    container: (baseStyles) => ({
      ...baseStyles,
      padding: 0,
      ...style
    }),
    multiValue: (baseStyles) => ({
      ...baseStyles,
      padding: 0,
      margin: "0px 2px"
    }),
    menu: (baseStyles) => ({
      ...baseStyles,
      marginTop:-0,
      background: light? "var(--darkgray)": "var(--background)",
      border: "2px var(--accent) solid",
      borderTop: "none",
      borderRadius: "0px 0px 7px 7px",
      color: "var(--white)",
      zIndex: 100
    })
  };

  function onKey(e){
    if(!menuOpen && e.key === "Enter" && onEnter)
      onEnter(e)
  }

  return (
      <div style={{position: "relative", width: "-webkit-fill-available"}}>
        {label && <label style={{color: "var(--white)", position: "absolute", top: -8, zIndex: 1, left: 10, background: light? "var(--darkgray)": "var(--background)", paddingLeft: 3, paddingRight: 3}}>{label}</label>}
        <Select noOptionsMessage={()=>"Keine Optionen"} className={"select"} options={options} isClearable={isSearchable && isClearable} isSearchable={isSearchable} placeholder={placeholder}
                onChange={onChange} defaultInputValue={defaultInputValue} hideSelectedOptions={isMulti}
                styles={styles} isMulti={isMulti} value={valueRaw !== null? options.find(e=>e.value===valueRaw): value} isDisabled={isDisabled} onMenuOpen={()=>setMenuOpen(true)}
                onMenuClose={()=>setMenuOpen(false)} onInputChange={onInputChange} onKeyDown={onKey}/>
      </div>
  );
};

